import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth'
import logs from './modules/logs'
import messages from './modules/messages'
import modal from './modules/modal'
import language from './modules/language'

Vue.use(Vuex);

const out = {
  modules: {
    language,
    messages,
    auth,
    logs,
    modal
  },
  state: {
    loading: false,
    title: null,
    tasks: [],
    actions: [],
    epp_services: [],
    epp_extensions: [],
    epp_log_enabled: false,
  },
  getters: {
    isLoading(state) {
      return state.loading
    },
    pageTitle(state) {
      return state.title
    },
    localTasks(state) {
      return state.tasks
    },
    localActions(state) {
      return state.actions
    },
    eppExtensions(state) {
      return state.epp_extensions
    },
    eppServices(state) {
      return state.epp_services
    },
    eppLogEnabled(state) {
      return state.epp_log_enabled
    },
    // https://stackoverflow.com/a/50593278/11493911
    user: (state, getters) => () => {
      return {
        id: getters['auth/getUserId'],
        rid: getters['auth/getRegistrarId'],
        authed: getters['auth/isAuthed'],
        roles: getters['auth/isAdmin'] ? ['admin'] : [],
        epp_services: getters.eppServices,
        epp_extensions: getters.eppExtensions,
        epp_log_enabled: getters.eppLogEnabled,
      };
    },
  },
  mutations: {
    setLoading(state, data) {
      Vue.set(state, 'loading', data)
    },

    setPageTitle(state, title) {
      if (typeof title !== "string" || title === "") {
        title = null
      }
      Vue.set(state, 'title', title)
    },

    setLocalTasks(state, tasks) {
      if (tasks === null || tasks instanceof Array === false) {
        Vue.set(state, 'tasks', [])
      } else {
        Vue.set(state, 'tasks', tasks)
      }
    },

    setLocalActions(state, actions) {
      if (actions === null || actions instanceof Array === false) {
        Vue.set(state, 'actions', [])
      } else {
        Vue.set(state, 'actions', actions)
      }
    },

    setEppServices(state, services) {
      Vue.set(state, 'epp_services', services);
      // persist these to avoid losing the data after page reload
      localStorage.setItem("epp_services", JSON.stringify(services));
    },

    setEppExtensions(state, exts) {
      Vue.set(state, 'epp_extensions', exts);
      // persist these to avoid losing the data after page reload
      localStorage.setItem("epp_extensions", JSON.stringify(exts));
    },

    setEppLogEnabled(state, val) {
      Vue.set(state, 'epp_log_enabled', val);
      // persist these to avoid losing the data after page reload
      localStorage.setItem("epp_log_enabled", val ? "true" : "false");
    }
  }
};

// the server will return the enabled services/extensions only upon login
// and we are only storing it in the vuex which means that upon page reload
// this data will be lost and we'll lose menu items - for ever.
// so to prevent this from happening, we will store these in the local storage,
// just like we do with the token itself.
// this may result in the server having different settings than what we expect
// but these settings can be changed only when the server is restarted with new configuration,
// which won't happen often(if at all) so we can semi-safely rely on this data.
// in case this would actually happen, all that would happen to us is that we
// would display(or hide) some menu items that would fail to execute expected functionality,
// which is a non-issue and once the user logs in again, we will get the correct data back anyway.
// if this becomes a big problem(doubtful) we can move these from the auth response
// into the token itself, but it will just waste network traffic, imho.
function initEpp() {
  let servicesJson = localStorage.getItem("epp_services");
  let extensionsJson = localStorage.getItem("epp_extensions");
  let tle = localStorage.getItem("epp_log_enabled");

  if (servicesJson !== null) {
    try {
      out.state.epp_services = JSON.parse(servicesJson)
    } catch(e) {}
  }

  if (extensionsJson !== null) {
    try {
      out.state.epp_extensions = JSON.parse(extensionsJson)
    } catch(e) {}
  }

  if (tle !== null) {
    try {
      out.state.epp_log_enabled = tle === "true"
    } catch(e) {}
  }
}

// call the init handler
initEpp();

export default new Vuex.Store(out);



// WEBPACK FOOTER //
// ./src/store/index.js